import React from 'react'
import { Chip } from '@material-ui/core'
import { useSafeFeatureGate } from './hooks/useSafeFeatureGate'
import { StatsigFeatureGateNames } from './constants'
import { useStatsigClient } from '@statsig/react-bindings'

/** @type {React.CSSProperties} */
const baseStyles = {
  position: 'fixed',
  zIndex: 9999,
  userSelect: 'none',
}

const positionMap = {
  'top-right': { ...baseStyles, top: 8, right: 8 },
  'bottom-right': { ...baseStyles, bottom: 8, right: 8 },
  'top-left': { ...baseStyles, top: 8, left: 8 },
  'bottom-left': { ...baseStyles, bottom: 8, left: 8 },
}

/**
 * Small, unobtrusive badge/banner to show feature flag status
 * Usage: Import and render this component anywhere in the builder
 * @param {string} position - Position style: 'top-right', 'top-left', 'bottom-right', 'bottom-left'
 */
const StatsigFeatureBadge = ({ gateName = StatsigFeatureGateNames.WEB_HELLO_WORLD, position = 'top-left' }) => {
  const featureGate = useSafeFeatureGate(gateName)
  const { client } = useStatsigClient()

  // Don't show if there's no client (to avoid clutter)
  if (featureGate.details?.reason === 'NoClient') {
    return <></>
  }

  client?.logEvent('feature gate evaluated', null, {
    feature_gate_name: gateName,
    component: 'StatsigFeatureBadge',
  })

  if (!featureGate.value) {
    return <></>
  }

  return (
    <Chip
      label="Statsig is on"
      color="primary"
      size="small"
      style={{
        ...(positionMap[position] || { ...baseStyles, top: 8, right: 8 }),
        fontSize: '11px',
        height: '24px',
        opacity: 0.8,
      }}
    />
  )
}

export default StatsigFeatureBadge
